<!-- tooltip container -->
<div class="tooltip-container">
  <div class="mr-2">
    <svg alt="Infobox Icon" aria-label="Infobox Icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M10 18.4375C14.6599 18.4375 18.4375 14.6599 18.4375 10C18.4375 5.3401 14.6599 1.5625 10 1.5625C5.3401 1.5625 1.5625 5.3401 1.5625 10C1.5625 14.6599 5.3401 18.4375 10 18.4375Z"
        stroke="#297AA6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M11.875 14.875H8.875C8.46079 14.875 8.125 14.5392 8.125 14.125C8.125 13.7108 8.46079 13.375 8.875 13.375H9.4375C9.54105 13.375 9.625 13.2911 9.625 13.1875V9.8125C9.625 9.70895 9.54105 9.625 9.4375 9.625H8.875C8.46079 9.625 8.125 9.28921 8.125 8.875C8.125 8.46079 8.46079 8.125 8.875 8.125H9.625C10.4534 8.125 11.125 8.79657 11.125 9.625V13.1875C11.125 13.2911 11.2089 13.375 11.3125 13.375H11.875C12.2892 13.375 12.625 13.7108 12.625 14.125C12.625 14.5392 12.2892 14.875 11.875 14.875Z"
        fill="#297AA6" />
      <path
        d="M10.375 4.75C10.9963 4.75 11.5 5.25368 11.5 5.875C11.5 6.49632 10.9963 7 10.375 7C9.75368 7 9.25 6.49632 9.25 5.875C9.25 5.25368 9.75368 4.75 10.375 4.75Z"
        fill="#297AA6" />
    </svg>
  </div>
  <div class="d-flex flex-column" style="padding-top: 0.1rem;">
    <ng-content select=".info-content"></ng-content>
  </div>
</div>
